import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';
import {
    Box,
    Flex,
    Loader,
    List,
    Image,
    Text,
    Label,
    Segment,
    Button,
    RadioGroup,
    Divider,
    Tooltip,
    Provider,
    teamsTheme,
} from "@fluentui/react-northstar";
import { InfoIcon, TeamsMonochromeIcon } from '@fluentui/react-icons-northstar';
import { initializeIcons, Icon } from '@fluentui/react';
import { getMeetingsData, getAppConfig, getAppSettings } from '../../api/publicapp-api';
import "./meetings.scss";
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";

interface IState {
    theme: string,
    processoId: string,
    embed: boolean,
    loading: boolean,

    meetingsData: any,
    selectedMeeting: any,
    appConfigs: any,
    appSettings: any,
    tipoCategoia: any, 
}

export interface IAppSettings {
    token: string | null,
    telemetry: string | null,
    theme: string | null
}

export type MeetingsDataPageProps = {} & RouteComponentProps & WithTranslation;

class MeetingsDataPage extends React.Component<MeetingsDataPageProps, IState> {
    token?: string | null = null;
    telemetry?: any = null;
    theme?: string | null;
    locale?: string | null;
    userObjectId?: string = "";
    tenantId?: string = "";
    private localize: TFunction;
        
    appSettings: IAppSettings = { telemetry: "", theme: "", token: "" };

    constructor(props: MeetingsDataPageProps) {
        super(props);

        this.localize = this.props.t;
        initializeIcons();
        let search = window.location.search;
        let params = new URLSearchParams(search);
        this.theme = params.get("theme");
        this.telemetry = this.appSettings.telemetry = params.get("telemetry");
        this.locale = params.get("locale");

        this.state = {
            loading: false,
            theme: this.theme ? this.theme : "default",
            processoId: params.get("p") ?? "",
            embed: params.has("embed") ?? false,
            meetingsData: null,
            selectedMeeting: null,
            appConfigs: null,
            appSettings: null,
            tipoCategoia: null,
        }

        window.localStorage.setItem("appsettings", JSON.stringify(this.appSettings));
    }


    /**
    * Used to initialize this component.
    */
    public async componentDidMount() {
        this.getAppConfig();
        this.getAppSettings();

        if (!this.state.embed)
            this.getMeetingsDataResponse();
        else
            this.setState({ loading: false, meetingsData: [] });
    }

    /**
     * Parse week days with locale
     * */
    public daysOfWeekLocale = (day: string) => {
        return day
            .replace(/segunda-feira/, this.localize('SegundaFeira'))
            .replace(/terça-feira/, this.localize('TercaFeira'))
            .replace(/quarta-feira/, this.localize('QuartaFeira'))
            .replace(/quinta-feira/, this.localize('QuintaFeira'))
            .replace(/sexta-feira/, this.localize('SextaFeira'))
            .replace(/sabado/, this.localize('Sabado'))
            .replace(/domingo/, this.localize('Domingo'))
    }

    /**
     * Get Meetings Data
     * */
    private async getMeetingsDataResponse() {

        this.setState({ loading: true });
        let response = await getMeetingsData();       

        if (response.status === 200 && response.data) {
            this.setState({
                meetingsData: response.data,
            });
        }
        
        this.setState({ loading: false });
    }

    /**
     * Get Meetings Data Filter
     * */
    private async getMeetingsDataFilter(tipoCategoria?: string) {

        let response = await getMeetingsData(tipoCategoria);

        if (response.status === 200 && response.data) {
            this.setState({
                meetingsData: response.data,
            });
        }
    }

    /**
     * Get App Configs
     * */
    private async getAppConfig() {
        let response = await getAppConfig();
        if (response.status === 200 && response.data) {            
            this.setState({
                appConfigs: response.data,
            });

            document.title = this.state.appConfigs.pageTitle;
        }
    };

    /**
     * Get App Settings
     * */
    private async getAppSettings() {
        let response = await getAppSettings();
        if (response.status === 200 && response.data) {
            this.setState({
                appSettings: response.data,
            });
        }
    };

    /**
     * Render the Documentos of processo.
     * */
    private renderMeetingsData() {
        return this.state.meetingsData.map((meeting: any) => {
            var horarios = '';

            if (meeting.horarioAtendimentoDias) {
                horarios += `${this.localize("HorariosAtendimento")}: ` + this.daysOfWeekLocale(meeting.horarioAtendimentoDias);
            }

            if (meeting.horarioAtendimentoInicial) {
                horarios += ` ${this.localize("Das")} ` + meeting.horarioAtendimentoInicial;
            }

            if (meeting.horarioAtendimentoFinal) {
                horarios += ` ${this.localize("Ate")} ` + meeting.horarioAtendimentoFinal + ` (${this.localize("HorarioBrasilia")})`;
            }

            return {
                'key': meeting.Ancora,
                'header': (
                    <Flex gap="gap.medium" vAlign="center">
                        <Flex>
                            {meeting.name}
                        </Flex>

                        {horarios != "" &&
                            <Tooltip trigger={<Icon className="clock-icon" iconName="Clock" />} content={horarios} position="after" align="center" />
                        }
                    </Flex>
                 ),
                'content': '',
                'endMedia': (
                    <Flex gap="gap.large">
                        <Button icon={<TeamsMonochromeIcon />} content={this.localize("Entrar")} onClick={() => { window.open(`/meeting/${meeting.Ancora}`) }} primary />
                    </Flex>
                )
            }
        });
    }

    /**
     * Render the Tipos Categoria.
     * */
    private getItemsTipoCategoria() {
        var items: any[];

        if (this.state.embed) {
            items = [];
        } else {
            items = [
                {
                    name: "TODOS",
                    key: "TODOS",
                    label: "TODOS",
                    value: "TODOS",
                }
            ];
        }

        this.state.appSettings?.tipoCategoria?.map((tipoCategoria: any, index: number) => {
            items.push(                
                {
                    name: tipoCategoria,
                    key: (index + 1).toString(),
                    label: tipoCategoria,
                    value: tipoCategoria,
                }                
            );
        });

        return items;
    }

    /**
     * Change Tipos Categoria.
     * */
    private onTipoCategoriaChanged = (event: any, data: any) => {
        var tipoCategoria = data.value; 
        this.getMeetingsDataFilter(tipoCategoria);
    }

    /**
     * Render this component.
     * */
    public render(): JSX.Element {
        if (this.state.loading) {
            return (
                <Flex gap="gap.small" hAlign="center" vAlign="center" styles={{ margin: "20% 0" }}>
                    <Flex.Item align="end">
                        <Loader label={this.localize("Carregando")} />
                    </Flex.Item>
                </Flex>
            );
        }
        else if (this.state.meetingsData) {
            return (
                <Provider theme={teamsTheme} styles={{ background: 'transparent' }}>
                    {this.state.appConfigs &&
                        <div hidden={this.state.embed} className="header">
                            <Segment
                                className="headerLine"
                                inverted
                            >
                                <Flex>
                                    <Flex.Item>
                                        <Flex gap="gap.small" vAlign="center">
                                            <Image src="/images/logo.png" />
                                            <Text weight="semibold" content={this.localize("BalcaoVirtual").toUpperCase()} size="medium" />
                                        </Flex>
                                    </Flex.Item>
                                    <Flex.Item grow>
                                        <Flex hAlign="center" vAlign="center">
                                            <Label className="headerLabel" content={this.state.appConfigs.tribunal} />
                                        </Flex>
                                    </Flex.Item>
                                    <Flex.Item>
                                        <Flex gap="gap.smaller" vAlign="center" className="sobre">
                                            <InfoIcon outline />
                                            <Text weight="light" content={this.localize("Sobre")} size="small" />
                                        </Flex>
                                    </Flex.Item>
                                </Flex>
                            </Segment>
                        </div>
                    }
               
                    <Flex gap="gap.small" hAlign="center" vAlign="center" column padding="padding.medium">
                        
                        <Flex.Item align="center">
                            <Box className={this.state.embed ? "box-meetings fill" : "box-meetings"}>

                                {this.state.appSettings?.tipoCategoria &&
                                    <React.Fragment>
                                        <Flex>
                                            <Flex.Item grow>
                                                <RadioGroup
                                                    className={"radioGroupTipoCategoria"}
                                                    defaultCheckedValue={this.state.embed? "1" : "TODOS"}
                                                    items={this.getItemsTipoCategoria()}
                                                    onCheckedValueChange={this.onTipoCategoriaChanged}
                                                />                                           
                                            </Flex.Item>
                                        </Flex>
                                        <Divider hidden={this.state.embed && !this.state.meetingsData?.length} />
                                    </React.Fragment>
                                }

                                {!this.state.embed &&
                                    (this.state.meetingsData?.length > 0 ?
                                        <List key="items-meetings" items={this.renderMeetingsData()} />
                                            :
                                        <Text styles={{ margin: "10px" }} align="center" content={this.localize("NenhumaUnidade")} />)
                                }

                                {this.state.embed &&
                                    (this.state.meetingsData?.length > 0 ?
                                        <List key="items-meetings" items={this.renderMeetingsData()} />
                                        :
                                        <React.Fragment />)
                                }
                                
                            </Box>
                        </Flex.Item>
                    </Flex>
                </Provider>
            );
        }

        return (
            <div></div>
        );
    }
}

const meetingsDataPageWithTranslation = withTranslation()(MeetingsDataPage);
export default meetingsDataPageWithTranslation;